import React, { useState } from 'react'
import './Carousel.css'

const Indicators = ({ index, data, prev, next }) => {
    return (
        <div className="indicators">
            <div className="material-icons icon--medium" onClick={prev} >arrow_back</div>
            <span className="text--large">{parseInt(index)}</span><span className="bold">/{data.length}</span>
            <span className="material-icons  icon--medium" onClick={next} >arrow_forward</span>
        </div>
    )
}

const Slide = (props) => {
    const { item } = props;
    return (
        <div className="slide">
            <div className="slide__description">
                <h1 className="heading--large">{item.header}</h1>
                <div>
                    <p className="text--small">{item.description}</p>
                    <Indicators {...props}/>
                </div>
            </div>
            <div className="slide__services">
                
                <ul className="text--small">
                <h1 className="heading--small">Services</h1>
                {item.services.map((service, index) => {
                    return <li key={index}>{service}</li>
                })}
                </ul>
            </div>
        </div>
    )
}

const Carousel = ({ data }) => {
    
    const [current, setCurrent] = useState(0)
    const length = data.length
  
    const nextSlide = () => setCurrent(current === length - 1 ? 0 : current + 1)
    const prevSlide = () => setCurrent(current === 0 ? length - 1 : current - 1)
  
    if (!Array.isArray(data) || data.length <= 0) return null

    return (
        <div className="slides">
        {data.map((item, index) => {
            return (
                <div className={index === current ? 'slides__container active' : 'slides__container'} key={index}>
                        {index === current && (
                            <Slide key={index} index={index + 1} item={item} data={data} next={nextSlide} prev={prevSlide} />
                        )}
                </div>
            )
        })}        
        </div>
    )
}

export default Carousel
